import { useInViewport } from 'ahooks';
import type {
  DetailedHTMLProps,
  FC,
  ImgHTMLAttributes,
  MutableRefObject,
} from 'react';
import { useEffect, useRef, useState } from 'react';
import { PLACEHOLDER_IMG } from '@/utils/constant';

type IProps = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  loadingImg?: false | string;
};

const LazyImage: FC<IProps> = ({ src, ref, loadingImg, ...imgProps }) => {
  const imgRef = useRef(null);
  const img = ref || imgRef;
  const flag = useRef(false);
  const [visible, setVisible] = useState(false);
  const [inViewport] = useInViewport(img as MutableRefObject<Element>);
  loadingImg =
    loadingImg === false
      ? ''
      : typeof loadingImg === 'string'
      ? loadingImg
      : PLACEHOLDER_IMG;

  useEffect(() => {
    if (inViewport && !flag.current) {
      flag.current = true;
      setVisible(true);
    }
  }, [inViewport]);

  const imgSrc = visible && src ? src : loadingImg;

  return <img src={imgSrc} ref={img} {...imgProps} />;
};

export default LazyImage;
